(function () {
  'use strict';
  function observeCartFetch(original, changed, base) {
    return function (input, init) {
      return original.apply(this, arguments).then(response => {
        try {
          const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, base);
          const method = String(init?.method || input?.method || 'GET').toUpperCase();
          if (response.ok && method === 'POST' && url.origin === new URL(base).origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname)) changed();
        } catch (error) {}
        return response;
      });
    };
  }
  function decide(attrs, cartId, count, scan) {
    if (scan) return 'start';
    if (attrs.hsia_qr_source !== 'coolcomfort') return 'none';
    if (attrs.hsia_qr_cart !== cartId || (attrs.hsia_qr_had_items === '1' && count === 0)) return 'clear';
    return 'keep';
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {decide, observeCartFetch};
    return;
  }
  if (window.hsiaQrAttribution) return;
  const keys = ['hsia_qr_source', 'hsia_qr_cart', 'hsia_qr_had_items', 'hsia_qr_visit'];
  const root = window.Shopify?.routes?.root || '/';
  const cartFetch = window.fetch.bind(window);
  let scan = new URL(location.href).searchParams.get('qr_source') === 'coolcomfort';
  let active = null;
  let queued = Promise.resolve();
  let pending = false;
  async function request(path, body) {
    const response = await cartFetch(root + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      ...(body ? {body: JSON.stringify(body)} : {}),
      signal: AbortSignal.timeout(8000)
    });
    if (!response.ok) throw new Error('QR cart update failed');
    return response.json();
  }
  async function fingerprint(value) {
    const bytes = new TextEncoder().encode(String(value).split('?')[0]);
    const digest = await crypto.subtle.digest('SHA-256', bytes);
    return Array.from(new Uint8Array(digest), b => b.toString(16).padStart(2, '0')).join('');
  }
  function updateForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      const values = {'_hsia_qr_source': active?.hsia_qr_source || '', '_hsia_qr_visit': active?.hsia_qr_visit || ''};
      for (const [key, value] of Object.entries(values)) {
        let input = form.querySelector('[data-hsia-qr="' + key + '"]');
        if (!value) { if (input) input.remove(); continue; }
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[' + key + ']';
          input.dataset.hsiaQr = key;
          form.append(input);
        }
        if (input.value !== value) input.value = value;
      }
    });
  }
  async function synchronize() {
    pending = true;
    document.documentElement.dataset.hsiaQrPending = 'true';
    try {
      let cart = await request('cart.js');
      const id = await fingerprint(cart.token);
      const attrs = cart.attributes || {};
      const action = decide(attrs, id, cart.item_count, scan);
      if (action === 'start') {
        const next = {hsia_qr_source: 'coolcomfort', hsia_qr_cart: id, hsia_qr_had_items: cart.item_count ? '1' : '0', hsia_qr_visit: crypto.randomUUID()};
        cart = await request('cart/update.js', {attributes: next});
        active = next;
        scan = false;
        const url = new URL(location.href);
        url.searchParams.delete('qr_source');
        history.replaceState(history.state, '', url);
      } else if (action === 'clear') {
        await request('cart/update.js', {attributes: Object.fromEntries(keys.map(k => [k, '']))});
        active = null;
      } else if (action === 'keep') {
        active = Object.fromEntries(keys.map(k => [k, attrs[k] || '']));
        if (cart.item_count && active.hsia_qr_had_items !== '1') {
          await request('cart/update.js', {attributes: {hsia_qr_had_items: '1'}});
          active.hsia_qr_had_items = '1';
        }
      } else active = null;
      updateForms();
      window.hsiaQrAttribution.status = active ? 'attributed' : 'unattributed';
    } catch (error) {
      active = null;
      updateForms();
      window.hsiaQrAttribution.status = 'error';
      console.warn('HSIA QR attribution could not be saved.');
    } finally {
      pending = false;
      delete document.documentElement.dataset.hsiaQrPending;
    }
  }
  function refresh() {
    queued = queued.then(synchronize, synchronize);
    window.hsiaQrAttribution.ready = queued;
    return queued;
  }
  window.hsiaQrAttribution = {status: 'pending', ready: queued, refresh};
  window.fetch = observeCartFetch(window.fetch, refresh, location.href);
  new MutationObserver(updateForms).observe(document.documentElement, {childList: true, subtree: true});
  document.addEventListener('on:cart:after-merge', refresh);
  document.addEventListener('on:cart:add', refresh);
  document.addEventListener('on:cart:change', refresh);
  document.addEventListener('shopify:section:load', updateForms);
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  refresh();
}());

